import React from 'react'

import { ReactComponent as DevicesSmallIcon } from '../../../assets/icons/devices-small.svg'
import { ReactComponent as DevicesMediumIcon } from '../../../assets/icons/devices-medium.svg'
import { ReactComponent as DevicesLargeIcon } from '../../../assets/icons/devices-large.svg'

import { ReactComponent as FolderSmallIcon } from '../../../assets/icons/folder-small.svg'
import { ReactComponent as FolderMediumIcon } from '../../../assets/icons/folder-medium.svg'
import { ReactComponent as FolderLargeIcon } from '../../../assets/icons/folder-large.svg'

function ImageUploadPanel({ uploadImage, openImageModal, getImageDataAndInitializePaths }) {
  const onImageChange = async (e) => {
    console.log(e.target.files)

    if (e.target.files && e.target.files[0]) {
      // onImageUpload(URL.createObjectURL(e.target.files[0]))
      getImageDataAndInitializePaths(await uploadImage(e.target.files[0]))
    }

    e.target.value = ''
  }
  return (
    <div className='sg-absolute sg-rounded-[4px] md:sg-rounded-[6px] xl:sg-rounded-[8px] sg-shadow-strong sg-flex sg-flex-col sg-items-center sg-justify-center sg-border sg-border-sk-border-default sg-bg-sk-white sg-divide-y sg-divide-sk-border-default'>
      <label
        className='sg-w-[130px] md:sg-w-[170px] xl:sg-w-[205px] sg-flex sg-items-center sg-justify-center sg-gap-4 sg-px-8 sg-py-6 sg-cursor-pointer md:sg-gap-8 xl:sg-gap-12 xl:sg-px-16 xl:sg-py-12 
          sg-rounded-t-[4px] md:sg-rounded-t-[6px] xl:sg-rounded-t-[8px] sg-text-caption2-regular sg-text-sk-label-info sg-hover:bg-sk-background-normal-alternative'
      >
        <input
          type='file'
          className='sg-hidden'
          accept='.jpg, .jpeg, .png'
          onChange={onImageChange}
        />
        <i className='sg-flex md:sg-hidden sg-items-center sg-justify-center sg-w-[22px] sg-h-[22px] md:sg-w-[28px] md:sg-h-[28px]'>
          <DevicesSmallIcon />
        </i>
        <i className='sg-hidden md:sg-flex xl:sg-hidden sg-items-center sg-justify-center sg-w-[22px] sg-h-[22px] md:sg-w-[28px] md:sg-h-[28px]'>
          <DevicesMediumIcon />
        </i>
        <i className='sg-hidden xl:sg-flex sg-items-center sg-justify-center sg-w-[22px] sg-h-[22px] md:sg-w-[28px] md:sg-h-[28px]'>
          <DevicesLargeIcon />
        </i>
        <p className='sg-text-caption2-regular md:sg-text-body2-regular xl:sg-text-body1-regular'>
          이 기기에서 불러오기
        </p>
      </label>
      <label
        className='sg-w-[130px] md:sg-w-[170px] xl:sg-w-[205px] sg-flex sg-items-center sg-justify-center sg-gap-4 sg-px-8 sg-py-6 sg-cursor-pointer md:sg-gap-8 xl:sg-gap-12 xl:sg-px-12 xl:sg-py-14 
          sg-rounded-b-[4px] md:sg-rounded-b-[6px] xl:sg-rounded-b-[8px] sg-text-caption2-regular sg-text-sk-label-info sg-hover:bg-sk-background-normal-alternative'
      >
        <input className='sg-hidden' onClick={() => openImageModal()} />
        <i className='sg-flex md:sg-hidden sg-items-center sg-justify-center sg-w-[22px] sg-h-[22px] md:sg-w-[28px] md:sg-h-[28px]'>
          <FolderSmallIcon />
        </i>
        <i className='sg-hidden md:sg-flex xl:sg-hidden sg-items-center sg-justify-center sg-w-[22px] sg-h-[22px] md:sg-w-[28px] md:sg-h-[28px]'>
          <FolderMediumIcon />
        </i>
        <i className='sg-hidden xl:sg-flex sg-items-center sg-justify-center sg-w-[22px] sg-h-[22px] md:sg-w-[28px] md:sg-h-[28px]'>
          <FolderLargeIcon />
        </i>
        <p className='sg-text-caption2-regular md:sg-text-body2-regular xl:sg-text-body1-regular'>
          자료실에서 불러오기
        </p>
      </label>
    </div>
  )
}

export default ImageUploadPanel
